var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilver2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 635,
    viewBox: "0 0 644 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 291.8V158.1C0.399902 141.7 9.09993 126.6 23.2999 118.5L139.1 51.7L277.8 131.8V291.9L139.1 372L0.399902 291.8Z",
    fill: "#B5A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M643.8 291.8V158.1C643.8 141.7 635.1 126.6 620.9 118.5L505.1 51.7L366.4 131.8V291.9L505.1 372L643.8 291.8Z",
    fill: "#676077"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M505.2 51.7L613.5 114.2L634 137.4L366.5 291.8V131.7L505.2 51.7Z",
    fill: "#B5A5B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M505.2 63.2L616 127.2C627 133.6 633.9 145.4 633.9 158.2V286L505.2 360.3L376.5 286V137.5L505.2 63.2ZM505.2 51.7L366.5 131.8V291.9L505.2 372L643.9 291.9V158.1C643.9 141.7 635.2 126.6 621 118.5L505.2 51.7Z",
    fill: "#B5A5B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139 51.7L36.6001 110.8L28.4001 115.5L10.1001 137.3L277.7 291.8V131.7L139 51.7Z",
    fill: "#FEF6FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139 63.2L267.7 137.5V286L139 360.3L10.3 286V158.1C10.3 145.4 17.2 133.5 28.2 127.1L139 63.2ZM139 51.7L23.2 118.5C8.99995 126.7 0.300049 141.8 0.300049 158.1V291.8L139 371.9L277.7 291.8V131.7L139 51.7Z",
    fill: "#B5A5B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6001 476V159L322.1 0.5L596.6 159V476L322.1 634.4L47.6001 476Z",
    fill: "#B5A5B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 634.4L596.6 475.9L547.6 447.6L342.1 566.3C329.7 573.4 322.1 586.6 322.1 600.9V634.4Z",
    fill: "#676077"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6001 476L322.1 634.5V601C322.1 586.7 314.5 573.5 302.1 566.4L116.5 459.3C104.1 452.2 88.9001 452.2 76.6001 459.3L47.6001 476Z",
    fill: "#A88696"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 34V4L51.8 161.4L76.6 175.7C89 182.8 104.2 182.8 116.5 175.7L302.1 68.6C314.5 61.5 322.1 48.3 322.1 34Z",
    fill: "#FEF6FA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M593.5 474.1L592.5 161.4L567.7 175.7C555.3 182.8 547.7 196 547.7 210.3V447.6L593.5 474.1Z",
    fill: "#676077"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 12L586.6 164.7V470.1L322.1 622.8L57.6001 470.1V164.7L322.1 12ZM322.1 0.5L47.6001 159V476L322.1 634.5L596.6 476V159L322.1 0.5Z",
    fill: "#B5A5B7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M498.9 197.4L371.3 123.7C356.4 115.1 339.4 110.5 322.2 110.5C305 110.5 288 115.1 273.1 123.7L145.5 197.4C135.5 203.2 129.3 213.9 129.3 225.4V296.9C129.3 322.5 139.8 347 158.1 364.7V369.9C158.1 406.4 177.7 440.4 209.2 458.6L322.2 523.9L435.2 458.6C467.6 439.9 485.7 406.6 486.3 364.7C504.7 346.9 515.1 322.5 515.1 296.9V225.4C515.1 213.9 508.9 203.2 498.9 197.4Z",
    fill: "#1C1128"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 323.2L167.1 236V296.9C167.1 317 177.8 335.6 195.2 345.6L195.9 346V369.9C195.9 393 208.1 414.2 228 425.7L322 480L416 425.7C435.9 414.2 448.1 393 448.1 362.7V346L448.8 345.6C466.2 335.5 476.9 317 476.9 296.9V236L322.1 323.2Z",
    fill: "#B5A5B7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 323.2V480L416.1 425.7C436 414.2 448.2 393 448.2 362.7V346L448.9 345.6C466.3 335.5 477 317 477 296.9V236L322.1 323.2Z",
    fill: "#676077"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 253.1L317.3 331.9L322.2 334.7L327.1 331.9L467.2 253.1V296.9C467.2 313.4 458.3 328.7 444.1 337L443.4 337.4L438.4 340.3V346.1V362.8C438.4 388.1 429 406.9 411.3 417.1L322.3 468.5L233.3 417.1C216.6 407.5 206.2 389.4 206.2 370V346V340.2L201.2 337.3L200.5 336.9C186.2 328.7 177.4 313.3 177.4 296.8V253.1H177.2ZM477.1 236L322.1 323.2L167.1 236V296.9C167.1 317 177.8 335.6 195.2 345.6L195.9 346V369.9C195.9 393 208.1 414.2 228 425.7L322 480L416 425.7C435.9 414.2 448.1 393 448.1 362.7V346L448.8 345.6C466.2 335.5 476.9 317 476.9 296.9V236H477.1Z",
    fill: "#B5A5B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206 340.3L322.1 405.6V417.1L206 351.7V340.3Z",
    fill: "#676077"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M438.2 340.3L322.1 405.6V417.1L438.2 351.7V340.3Z",
    fill: "#B5A5B7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.6 215.2L322.1 291.1L453.6 215.2L352.2 156.7C333.5 145.9 310.6 145.9 291.9 156.7L190.6 215.2Z",
    fill: "#698445"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M352.3 156.6C343 151.2 332.6 148.5 322.2 148.5V291.1L453.7 215.2L352.3 156.6Z",
    fill: "#1F4927"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 236L195.9 218.2L322.1 291.1L448.3 218.2L322.1 236Z",
    fill: "#143321"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 158.5C330.9 158.5 339.6 160.8 347.2 165.2L433.6 215.1L322.1 279.5L210.6 215.1L297 165.2C304.6 160.9 313.3 158.5 322.1 158.5ZM322.1 148.5C311.7 148.5 301.3 151.2 292 156.6L190.6 215.1L322.1 291L453.6 215.1L352.2 156.6C342.9 151.2 332.5 148.5 322.1 148.5Z",
    fill: "#2B5E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver2);
export default __webpack_public_path__ + "static/media/silver-2.80d78884f7e217605cecc8d085ff66ab.svg";
export { ForwardRef as ReactComponent };